export const TRACK_UPDATE_SORT = 'TRACK_UPDATE_SORT';
export const TRACK_UPDATE_PAGE = 'TRACK_UPDATE_PAGE';
export default {
    namespaced: true,
    state() {
        return {
            sort: null,
            page: 1
        };
    },
    getters: {},
    mutations: {
        [TRACK_UPDATE_SORT](state, payload) {
            state.sort = payload;
        },
        [TRACK_UPDATE_PAGE](state, payload) {
            state.page = payload;
        }
    },
    actions: {}
};
